// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__9Zqvc","logoContainer":"LandingPage_logoContainer__Vbu30"};